export const resetPDFViewer = () => ({
  type: "RESET_PDF_VIEWER"
});

export const setPDFViewer = pdfViewer => ({
  type: "SET_PDF_VIEWER",
  pdfViewer
});



// WEBPACK FOOTER //
// ./src/actions/actions/pdf-viewer.js